var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6995 2.3667H3.29954C2.78388 2.3667 2.36621 2.78437 2.36621 3.30003V11.7C2.36621 12.2157 2.78388 12.6334 3.29954 12.6334H11.6995C12.2152 12.6334 12.6329 12.2157 12.6329 11.7V3.30003C12.6329 2.78437 12.2147 2.3667 11.6995 2.3667ZM11.0877 6.7879C11.0271 6.7935 10.9659 6.79723 10.9043 6.79723C10.2067 6.79723 9.59348 6.43883 9.23648 5.8961C9.23648 7.31896 9.23648 8.9383 9.23648 8.96536C9.23648 10.2184 8.22054 11.2338 6.96801 11.2338C5.71548 11.2334 4.69954 10.2174 4.69954 8.9649C4.69954 7.7119 5.71548 6.69643 6.96801 6.69643C7.01561 6.69643 7.06181 6.70063 7.10801 6.70343V7.82157C7.06134 7.81597 7.01608 7.80757 6.96801 7.80757C6.32868 7.80757 5.81021 8.32603 5.81021 8.96536C5.81021 9.6047 6.32821 10.1232 6.96801 10.1232C7.60781 10.1232 8.17248 9.61916 8.17248 8.97983C8.17248 8.95416 8.18368 3.76717 8.18368 3.76717H9.25188C9.35221 4.72243 10.1236 5.47657 11.0877 5.54563V6.7879Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.7292f6ceff2493628f2ed7e8e9526c14.svg";
export { ForwardRef as ReactComponent };